import Model from "../../Model.js";
import ReportTemplate from "../../reports/templates/ReportTemplate.js";

/**
 * Group the 3 report templates of a forecast template, namely, a P&L
 * report (aka. income statement), a balance sheet report and a cash
 * flow report.
 *
 * @param {ReportTemplate} incomeStatement - Template for the Income Statement
 * @param {ReportTemplate} balanceSheet - Template for the Balance Sheet
 * @param {ReportTemplate} cashFlow - Template for the Cash Flow
 */
export default class ReportTemplateManager extends Model {
	constructor({ incomeStatement, balanceSheet, cashFlow }) {
		super(...arguments);

		this._incomeStatementTemplate = incomeStatement;
		this._balanceSheetTemplate = balanceSheet;
		this._cashFlowTemplate = cashFlow;
	}

	getReportTemplates() {
		return {
			incomeStatement: this._incomeStatementTemplate,
			balanceSheet: this._balanceSheetTemplate,
			cashFlow: this._cashFlowTemplate,
		};
	}

	static transformMaterializationData(data, context) {
		super.transformMaterializationData(...arguments);

		data.incomeStatement &&= ReportTemplate.materialize(
			data.incomeStatement,
			context,
		);

		data.balanceSheet &&= ReportTemplate.materialize(
			data.balanceSheet,
			context,
		);

		data.cashFlow &&= ReportTemplate.materialize(data.cashFlow, context);
	}
}
